import { Check } from "lucide-react";
import { IMAGES } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, PrimaryButton, CTABanner } from "@/components/common";

export default function Financing() {
  usePageMeta("Financing Options", "Flexible financing options for your stucco project with A.D.N Stucco Inc. Get quality craftsmanship now and pay over time.");
  return (
    <div data-testid="financing-page">
      <PageHero label="Financing" title="Flexible financing options" subtitle="Quality stucco work shouldn't wait. Ask us about financing options that fit your budget." image={IMAGES.residential} />
      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <SectionLabel>Affordable Solutions</SectionLabel>
            <h2 className="text-4xl font-heading font-extrabold mt-6 leading-tight">Get the work you need, on a plan that works for you</h2>
            <p className="text-lg text-zinc-600 mt-6 leading-relaxed">Whether it's an unexpected repair or a full re-stucco, we want to make quality craftsmanship accessible. Ask about our financing options during your free estimate and we'll help you find a comfortable payment plan.</p>
            <ul className="space-y-4 mt-8">
              {["Free, no-obligation estimates", "Honest, transparent pricing", "Options for repairs & full projects", "Fast approval process", "No hidden fees"].map((t) => (
                <li key={t} className="flex items-center gap-3 text-zinc-700 font-medium"><Check size={20} className="text-adn-red" /> {t}</li>
              ))}
            </ul>
            <div className="mt-10"><PrimaryButton to="/contact" testid="financing-cta">Ask About Financing</PrimaryButton></div>
          </div>
          <img src={IMAGES.interior} alt="Financing your stucco project" className="w-full h-[480px] object-cover" />
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
